import React from "react";
import styles from "./SelectionButton.module.css";
import { Button } from "@mui/material";

export default function TreatmentButton({ label, selected, handleClick }) {
    const styles = {
        root: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "56px",
            backgroundColor: "#fff",
            cursor: "pointer",
            textTransform: "none",
            fontSize: { xs: ".8rem", sm: "1rem" },
            fontWeight: "bold",
            marginBlock: { xs: ".65rem", sm: "1rem" },
            transition: "600ms",
            height: { xs: "50px", sm: "70px", md: "80px" },
            minWidth: "300px",
            "&:hover": {
                backgroundColor: "rgb(0,125,179)",
                color: "#fff",
            },
        },
    };
    return (
        <Button
            sx={{
                ...styles.root,
                backgroundColor: selected ? "rgb(0,125,179)" : "#fff",
                color: selected ? "#fff" : "#000",
            }}
            onClick={() => handleClick(label)}
        >
            {label}
        </Button>
    );
}
